module.exports = __webpack_public_path__ + "img/cover_photo.cf1ee4a0.jpg";